
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    Dialog,
    DialogTitle,
    DialogContentText,
    DialogActions,
    DialogContent,
    Slide,
    Paper,
    FormControl,
    InputLabel,
    Select,
    Autocomplete,
    Stack,
    Badge,
    TextField,
    Tooltip,
    Divider
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import PushPinIcon from "@mui/icons-material/PushPin";
import BarChartIcon from "@mui/icons-material/BarChart";
import PieChartIcon from "@mui/icons-material/PieChart";
import SpeedIcon from "@mui/icons-material/Speed";
import TimelineIcon from "@mui/icons-material/Timeline";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckIcon from "@mui/icons-material/Check";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ListIcon from "@mui/icons-material/List";
import {useTheme} from '@mui/material/styles';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {BarChartConfigurationMenuComponent} from "./BarChartConfigurationMenu";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import Config from "../../config";
import { useAuth } from "../../hooks/useAuth";
import {ListViewModel,
        ListViewColumnModel} from '../../models/models';
import {BaseSuccessModel} from '../../models/modelsException';
import {PinModel,
        ListViewUIPreferenceModel,
        ListViewUIPreferenceJSON} from '../../models/modelsUserConfiguration';
import {upsertPin, deletePin} from "../../services/userConfigurationApi";


export const PinConfigurationComponent: React.FC<{
  listView: ListViewModel,
}> = ({
  listView
}) => {

  const styles = ContainerClasses();

  const {accessToken, onInvalidToken} = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  const [isMainPin, setIsMainPin] = useState<boolean>(false);
  const [displayType, setDisplayType] = useState<string>('List');

  const [anchorElBarChartMenu, setAnchorElBarChartMenu] = React.useState<null | HTMLElement>(null);

  useEffect(() => {
    if(listView.user_preference?.IsPinned_sys &&
       listView.user_preference?.Rank_sys === 1){
      setIsMainPin(true)
    } else {
      setIsMainPin(false)
    }
    if(listView.user_preference){
      setDisplayType(listView.user_preference.DisplayType_sys)
    }

//    setPinned(true)
  }, [listView])

  const handlePin = () => {

    const thisObjectName = 'ListView_mdt';
    if(isMainPin){
      deletePin(accessToken, thisObjectName, listView.Uuid_sys)
        .then((thisSuccess: BaseSuccessModel) => {
           enqueueSnackbar(thisSuccess.message, {
             variant: "success",
           });
           //onChange(listView)
           setIsMainPin(false)
        })
        .catch((err) => {
           enqueueSnackbar(err.message, {
             variant: "error",
           });
        })
    } else {
      upsertPin(accessToken, thisObjectName, listView.Uuid_sys)
        .then((thisPin: PinModel) => {
           enqueueSnackbar("Listview has been pinned", {
             variant: "success",
           });
           setIsMainPin(true)
           //onChange(listView)
        })
        .catch((err) => {
           enqueueSnackbar(err.message, {
             variant: "error",
           });
        })
      }
    }


  const getRank = () => {
    if(listView.user_preference &&
       listView.user_preference.IsPinned_sys){
         return listView.user_preference?.Rank_sys
       }
    return null
  }


  return (

    <Tooltip key={'pin'} title={isMainPin ? 'Unpin List': 'Pin List'}>
      <IconButton
        size="small"
        onClick={() => handlePin()}
        color={isMainPin ? 'primary': 'default'}
      >
        <Badge badgeContent={getRank()}>
          <PushPinIcon fontSize="small"/>
        </Badge>
      </IconButton>
    </Tooltip>

  );

};
